import { render, staticRenderFns } from "./ImageClipModal.vue?vue&type=template&id=b6d60e62&scoped=true&"
import script from "./ImageClipModal.vue?vue&type=script&lang=js&"
export * from "./ImageClipModal.vue?vue&type=script&lang=js&"
import style0 from "./ImageClipModal.vue?vue&type=style&index=0&id=b6d60e62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d60e62",
  null
  
)

export default component.exports